import type { MapGroupsShortType } from '@/entities/Inventory/GroupsMap'

export type InventoryMainType = {
  id: number
  name: string
  serial_number: string
  parents: {
    id: number
    type: number
    name: string
  }[]
  object_type: {
    id: number
    icon: string
    alias: string
  }
}

export type InventoryFigure = {
  id: number
  name: string
  geom_type: string
}

export type InventoryLineType = {
  id: number
  name: string
  code: keyof typeof InventoryLineTypeData
}

export type InventoryMapInfoType = {
  id: number
  name: string
  parent_id: number
  coordinates: number[][]
  parent_object?: {
    id: number
    name: string
    object_type: {
      icon: string
      object_name: string
    }
  }
  object_type: {
    id: number
    icon: string
    object_name?: string
  }
  is_projecting: boolean
  invent_object_type: {
    properties: {
      has_file: boolean
      is_connection_to_object: boolean
      is_journal_replace: boolean
      is_comment: boolean
      is_must_accept?: boolean
    }
    fields: {
      id: string
      name: string
      type: string
      items: {
        id: number
        name: string
      }[]
      multiple: boolean
      count_object: boolean
      default_value: string
      object_type: number
      is_system: boolean
    }[]
  }
  groups_map: MapGroupsShortType[]
  connection_object_list_id: number
  fields: {
    id: string
    value: string
  }[]
  files: {
    file: string
    filename: string
    ext: string
    size: string
  }[]
  comment: string
  stats: InventoryStatsType
  accept_status?: string
}

export type InventoryStatsType = {
  by_type: {
    [key: string]: {
      count: number
      length_m: number
      area_m2: number
      subtypes: {
        [key: string]: {
          count: number
          meters: number
          ids: number[]
        }
      }
    }
  }
  value: {
    [key: string]: number
  }
  unit: {
    [key: string]: string
  }
  object_ids: number[]
}

export const InventoryLineTypeData = {
  solid: [16, 0],
  dashed: [16, 10],
  'dot-dashed': [16, 10, 2, 10],
}
